export const PlaceType = {
    SPACE: "space",
    OFFICE: "office"
}